const ENERGY_LEVEL_TO_PERCENT = {
  low: 25,
  medium: 50,
  high: 75
}

export function energyPercentFromTrack(trackLike = {}) {
  const rawScore = trackLike.energy_score
  const numericScore = rawScore === null || rawScore === undefined || rawScore === '' ? NaN : Number(rawScore)

  if (Number.isFinite(numericScore)) {
    if (numericScore >= 70) {
      return 100
    }

    return Math.max(0, Math.min(100, numericScore))
  }

  const energyLevel = typeof trackLike.energy_level === 'string' ? trackLike.energy_level.toLowerCase() : null

  return ENERGY_LEVEL_TO_PERCENT[energyLevel] || null
}

export function energyBarCountFromPercent(percent) {
  if (!Number.isFinite(percent) || percent <= 0) {
    return 0
  }

  if (percent >= 70) {
    return 3
  }

  if (percent >= 40) {
    return 2
  }

  return 1
}
